import {
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoGridOneColumn,
    RaikoLabel, showInfoMessage
} from "@moeindal/base-raiko-panel-components";
import "./RaikoApkSelector.scss"
import icApk from "./ic-apk.svg"
import {useRef} from "react";
import {LinearProgress} from "@mui/material";
import {RaikoIconTypes} from "../../../raikoComponents/raikoIcon/RaikoIconTypes";
import {RaikoIcon} from "../../../raikoComponents/raikoIcon/RaikoIcon";

export default function RaikoApkSelector(
    {
        apkFile,
        setApkFile,
        apkFileName,
        setApkFileName,
        uploadedApkUrl,
        uploadedApkName = "",
        showUploadLoading,
        uploadPercent
    }
) {

    const apkFileSelectHint = "لطفا فایل APK مورد نظر خود را انتخاب نمایید. 🤖"

    const fileRef = useRef(null);


    function uploadApkFile({target: {files}}) {
        if (typeof files[0] !== 'undefined') {
            setApkFile(files[0])
            setApkFileName(files[0].name)
        }
    }

    function handleShowSelectFile() {
        fileRef.current.click()
    }


    return (
        <div className={"appVersionApkSelectContainer"}>
            <div className={"appVersionIconContainer"}>
                <RaikoIcon
                    icon={apkFileName || uploadedApkUrl ? RaikoIconTypes.icAndroidOs : RaikoIconTypes.icAndroidOsGray}
                    className={`appVersionIcon`}/>
            </div>
            <RaikoLabel
                text={apkFileName && apkFileName.length > 0 ? apkFileName :
                    uploadedApkUrl && uploadedApkUrl.length > 0 ? uploadedApkName :
                        apkFileSelectHint}
                className={"appVersionTitle"}
            />

            {
                uploadedApkUrl && uploadedApkUrl.length > 0 && apkFile === null &&
                <RaikoButtonSecondary
                    label={"کپی لینک دانلود"}
                    onClick={_ => {
                        navigator.clipboard.writeText(uploadedApkUrl);
                        showInfoMessage("لینک با موفقیت کپی شد!")
                    }}/>
            }


            <RaikoButtonPrimary
                label={"انتخاب نسخه"}
                onClick={handleShowSelectFile}
            />


            <input
                id='androidFile'
                type="file"
                ref={fileRef}
                hidden
                accept="application/vnd.android.package-archive"
                onChange={uploadApkFile}/>

            {
                showUploadLoading &&
                <div className={"loadingContainer"}>
                    <div>
                        <span className={"loadingHintTitle"}> ({uploadPercent + "%"}) در حال بارگزاری نسخه ی جدید، لطفا صبور باشید...</span>
                        <LinearProgress
                            hidden={showUploadLoading}
                            variant="buffer"
                            value={uploadPercent}
                            valueBuffer={0}
                        />
                    </div>
                </div>
            }

        </div>
    )
}
